import User from 'auth/User';
import { Nullable } from 'utils/types';
import { createPublicPermissions } from 'utils/user/permissions';
import { Action, ACTIONS } from 'auth/store/actions';
import { AUTH_STATUSES } from 'auth/types';

export type AuthStoreState = {
  status: string;
  accessToken: Nullable<string>;
  accessTokenExpire: Nullable<number>;
  user: User;
  loginError: Nullable<string>;
  isLogging: boolean;
};

const initialState: AuthStoreState = {
  status: AUTH_STATUSES.NOT_AUTHENTICATED,
  accessToken: null,
  accessTokenExpire: null,
  user: new User(0, '', null, createPublicPermissions(), '', []),
  loginError: null,
  isLogging: false,
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case ACTIONS.SET_ACCESS_TOKEN:
      const jwt = action.payload;
      return {
        ...state,
        accessToken: jwt ? jwt.access : null,
        accessTokenExpire: jwt ? jwt.expirationTimeStamp : null,
      };

    case ACTIONS.SET_USER_DATA:
      return {
        ...state,
        user: action.payload.user,
        status: AUTH_STATUSES.AUTHENTICATED,
      };

    case ACTIONS.SET_LOGIN_ERROR:
      return {
        ...state,
        loginError: action.payload.loginError,
      };

    case ACTIONS.CLEAR_USER:
      return initialState;

    case ACTIONS.SET_IS_LOGGING:
      return {
        ...state,
        isLogging: action.payload.isLogging,
      };

    default:
      return state;
  }
};

export default reducer;
